<template>
  <v-row class="ma-0 py-5 my-5" justify="center">
    <div style="position: absolute;">
      <v-img
        style="position: relative;top: -111px;"
        height="134"
        width="135"
        contain
        src="@/assets/membership/circledQuotesIcon.svg"
      />
    </div>
    <v-col
      class="mt-7"
      cols="12"
      style="font-weight: 800;font-size: 39.8594px;line-height: 54px;text-align: center;color: #576CB2;"
    >
      What Members Say About Us
    </v-col>
    <v-carousel
      class="testimonialsCarousel"
      :continuous="false"
      :cycle="cycle"
      :show-arrows="false"
      :height="$store.state.isMobile ? '450px' : '300px'"
      delimiter-icon="mdi-circle-medium"
      hide-delimiter-background
      light
    >
      <v-carousel-item v-for="(slide, i) in slides" :key="i">
        <v-row class="fill-height" align="center" justify="center">
          <v-col cols="4" :align="$store.state.isMobile ? 'center' : 'right'">
            <v-img
              max-height="200px"
              max-width="200px"
              :aspect-ratio="1 / 1"
              style="border-radius: 50%"
              src="@/assets/profile.svg"
            />
          </v-col>
          <v-col cols="8" class="px-3 px-md-8">
            <div
              style="font-weight: 300;font-size: 17px;line-height: 29px;color: #000000;"
            >
              {{ slide.text }}
            </div>
            <div
              class="mt-3"
              style="font-weight: 300;font-size: 19.9586px;line-height: 27px;color: #576CB2;"
            >
              {{ slide.name }},
              <span style="color: #0000009e;">{{ slide.place }}</span>
            </div>
          </v-col>
        </v-row>
      </v-carousel-item>
    </v-carousel>
  </v-row>
</template>

<script>
  export default {
    name: "MembershipTestimonials",
    components: {},
    data() {
      return {
        cycle: true,
        slides: [
          {
            initial: "M",
            name: "Mafaz",
            place: "United Arab Emirates",
            text:
              "First of all I would like to thank ebility for their kindness in providing for parents and caregivers some very useful information and resources that can help them in bringing up their special needs children.I would like to thank speaker for helping us parents be closer to our children in such a way that we can enjoy our lives with them in a better way. Since his session 9th January, I have become a better friend with my son, as I started adopting that positive mindset of joining my child in whatever he is doing, and he started liking that attitude.Thank you all once again and be blessed!",
          },
          {
            initial: "H",
            name: "Helen Grace Santos",
            place: "Phillippines",
            text:
              "Thank you, Eblity Team, speaker and the panelists in this workshop.  The lesson was enlightening and encouraging to try a new approach in getting my child's attention in a loving and joyful way.  I now realized why he asked at last Saturday's webinar if parents are willing to change their mindset in order to help their child with autism.  As I listened to the workshop earlier today, I realized I needed to do just that, to loosen up and have fun while I journey with my child in her development.  It was also amazing to see how The speaker is able to speak with the parents and ask them questions without prejudice or judgment.",
          },
          {
            initial: "P",
            name: "Preetinder K Chadha",
            place: "India",
            text:
              "As usual, Eblity and Tejashree have brought to light very relevant issues that parents normally have to run from pillar to post to address. Initiating the support group is a commendable step, too.",
          },
        ],
      };
    },
    created() {},
    computed: {},
    watch: {},
    methods: {},
    mounted() {},
  };
</script>

<style>
  .testimonialsCarousel
    > .v-carousel__controls
    > .v-item-group
    > .v-btn
    .v-btn__content
    .v-icon {
    color: #576cb2 !important;
    opacity: 1 !important;
  }
</style>
